// 管理画面の編集・削除ボタン押下時に対象テーブルのCSSを変更
$(() => {
  $('.user_table_row').each(function () {
    $(this).on('click', () => {
      $('.user_table_row').removeClass('selected')
      $(this).addClass('selected')
    })
  })
})